import {
  OPERATIONAL_HEALTH_ERROR,
  OPERATIONAL_HEALTH_REQUEST,
  OPERATIONAL_HEALTH_SUCCESS,
} from "./ActionType";

const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
};

const operationalHealthReducer = (state = initialState, action) => {
  switch (action.type) {
    case OPERATIONAL_HEALTH_REQUEST:
      return {
        ...state,
        isRequest: true,
        isError: false,
        error: null,
      };
    case OPERATIONAL_HEALTH_SUCCESS:
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case OPERATIONAL_HEALTH_ERROR:
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default operationalHealthReducer;
